import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
} from "../services/types/ComponentTypes";

export const screen_176_gate_pass_issue: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Gate Pass Issue",
        style: {
            // backgroundColor: "#F1F8E9",
        },
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "gate_pass_issue",
                columnNumber: "m1 t1 w1",
                TableName: "gate_pass_issue",
                DisplayName: "Gate Pass",
                Workflow: "service", // Assuming 'service' workflow or similar, adjusting if needed based on 103
                style: {
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                    padding: 10,
                },
                SubmitActions: [
                    {
                        Action: "Navigate",
                        Navigate: "modulev1/vehicleinsummary",
                    },
                ],
                Fields: [
                    {
                        componentType: LayoutTypes.GROUP,
                        Label: "",
                        BindValue: "cont_Action",
                        style: {
                            direction: FlexDirection.ROW,
                            padding: 0,
                            margin: 0,
                            marginBottom: 8,
                        },
                        childComponents: [
                            // {
                            //     componentType: ComponentType.BUTTON,
                            //     name: "Back",
                            //     Label: "Back",
                            //     BindValue: "btn_back",
                            //     onPressAction: "navigate",
                            //     ActionType: "Navigate",
                            //     style: {
                            //         backgroundColor: "var(--primary-dark)",
                            //         textColor: "#FFFFFF",
                            //         padding: 8,
                            //         borderRadius: 4,
                            //         fontSize: 14,
                            //     },
                            // },
                            {
                                componentType: ComponentType.BUTTON,
                                name: "lock",
                                Label: "lock",
                                BindValue: "lock",
                                onPressAction: "unlock",
                                ScreenId: "176",
                                ActionType: "Unlock",
                                LockBinding: true,
                                style: {
                                    backgroundColor: "var(--primary-green)",
                                    textColor: "#FFFFFF",
                                    padding: 8,
                                    marginBottom: 8,
                                    borderRadius: 4,
                                    fontSize: 14,
                                },
                            },
                            {
                                componentType: ComponentType.BUTTON,
                                name: "Print",
                                Label: "Print",
                                BindValue: "btn_Print",
                                onPressAction: "pdf",
                                Settings: "gate_pass_issue_print",
                                ActionType: "PDF",
                                toolTip: "Print Gate Pass",
                                Enabled: {
                                    Mode: ["View"],
                                },
                                style: {
                                    backgroundColor: "var(--primary-green)",
                                    textColor: "#FFFFFF",
                                    padding: 8,
                                    marginBottom: 8,
                                    borderRadius: 4,
                                    fontSize: 14,
                                },
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Gate Pass Details",
                        BindValue: "con_gate_pass_details",
                        style: {
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                IncludeLabel: true,
                                Label: "Gate Pass Issue Number",
                                PlaceHolder: "Will be auto generated (System)",
                                IsMandatory: false,
                                BindValue: "txt_gate_pass_number",
                                Json_Attribute: "gate_pass_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                AutoPopulate: true,
                                IsReadOnly: true,
                                AutoPopulate_format: "GP_[******]", // Assumed format
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Job No.",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "parentid",
                                Json_Attribute: "parent_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                showInSummary: false,
                                IsReadOnly: true,
                                LookupName: "gate_pass_jobcard",
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Status",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "gate_pass_status",
                                Json_Attribute: "gate_pass_status",
                                componentType: ComponentType.SELECT_DROPDOWN,
                                showInSummary: false,
                                LookupName: "Create Gate Pass",
                                IsVerticalView: true,
                                options: [
                                    { label: "Gate Pass Issued", value: "Gate Pass Issued" }
                                ],
                            },
                            {
                                Label: "",
                                BindValue: "gate_pass_report",
                                componentType: ComponentType.REPORT,
                                IncludeLabel: true,
                                Settings: "GatePassDetails", // Backend report name
                                Parent_Field: "parentid",
                            },

                            {
                                IncludeLabel: true,
                                Label: "Receiver Name",
                                PlaceHolder: "Enter receiver name",
                                IsMandatory: true,
                                BindValue: "txt_receiver_name",
                                Json_Attribute: "receiver_name",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Receiver Mobile Number",
                                PlaceHolder: "Enter mobile number",
                                IsMandatory: true,
                                BindValue: "txt_receiver_mobile",
                                Json_Attribute: "receiver_mobile",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsVerticalView: true,
                                inputType: InputType.PHONE,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Date Out / Time",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "date_out_time",
                                Json_Attribute: "out_time",
                                componentType: ComponentType.DATETIME_FIELD,
                                showInSummary: false,
                                IsVerticalView: true,
                                DefaultToday: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "KM Out",
                                PlaceHolder: "Enter KM Out",
                                IsMandatory: true,
                                BindValue: "txt_km_out",
                                Json_Attribute: "km_out",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsVerticalView: true,
                                inputType: InputType.NUMBER,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Remarks",
                                PlaceHolder: "Enter remarks",
                                IsMandatory: false,
                                BindValue: "txt_remarks",
                                Json_Attribute: "remarks",
                                componentType: ComponentType.TEXT_AREA,
                                showInSummary: false,
                                IsVerticalView: true,
                                rows: 3,
                            },
                        ],
                    },
                ],
            },
            {
                componentType: LayoutTypes.GRID,
                columnNumber: "m1 t2 w1",
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        name: "Submit",
                        Label: "Submit",
                        BindValue: "btn_submit",
                        onPressAction: "save",
                        ScreenId: "176",
                        ActionType: "Add",
                        style: {
                            backgroundColor: "var(--primary-green)",
                        },
                    },
                    {
                        componentType: ComponentType.BUTTON,
                        name: "Cancel",
                        Label: "Cancel",
                        BindValue: "btn_cancel",
                        onPressAction: "navigate",
                        ActionType: "Navigate",
                        style: {
                            backgroundColor: "var(--secondary-gray)",
                        },
                    },
                ],
            },
        ],
    },
];
